import { render } from "./MovementArrive.vue?vue&type=template&id=397a8598"
import script from "./MovementArrive.vue?vue&type=script&lang=js"
export * from "./MovementArrive.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__